export const SList = { 
  p: 0.4, 
  mb: 1 
};
